import Const from 'const';

class F1PerTeamDriverLimits {
    constructor(
        private readonly enabled = false,
        private readonly teamNames: string[] = [],
    ) {}

    isEnabled(): boolean {
        return this.enabled;
    }

    getAllTeamNames(): string[] {
        return this.teamNames;
    }

    isTeamDisallowed(teamName): boolean {
        return !this.teamNames.includes(teamName);
    }
}

const f1PerTeamDriverLimits = new F1PerTeamDriverLimits();

export default function (state = f1PerTeamDriverLimits, action) {
    if (action.type === Const.F1_PER_TEAM_DRIVER_LIMITS_SET_IS_USED) {
        state = new F1PerTeamDriverLimits(action.use, state.getAllTeamNames());
    } else if (action.type === Const.F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAM) {
        const teamNames = state.getAllTeamNames();
        const teamName = action.teamName;
        const changedTeamNames: string[] = teamNames.includes(teamName)
            ? teamNames.filter((existTeamName) => existTeamName !== teamName)
            : [...teamNames, teamName];

        state = new F1PerTeamDriverLimits(state.isEnabled(), changedTeamNames);
    } else if (action.type === Const.F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAMS) {
        state = new F1PerTeamDriverLimits(state.isEnabled(), action.teamNames);
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = new F1PerTeamDriverLimits();
    }

    return state;
}
